import components from '../config';
import { useContext, useRouter } from '@nuxtjs/composition-api';
import { v4 as uuidv4 } from 'uuid';
import { startsWith, trimStart } from "lodash-es";

export const PBHelper = () => ({
  createDynamicBackgroundImage: (src) => {
    const UUID = uuidv4();
    const imageId = UUID.split('-').pop();
    return {
      className: 'background-image-' + imageId,
      style: '.background-image-' + imageId + ' {background-image: url(' + src + ');}'
    };
  },
  getComponentName: (data) => {
    const component = components().find((n) => n.tag === data.attr?.['data-content-type']);

    return component ? component.name : 'ElementsHtmlCode';
  },
  getProductUrlKeys: (content) => {
    const urlKeys = content !== '[]' ? content.match(/(?:(https|http):\/\/)(.*?)(?=\")/g).filter((i) => /\.html/.test(i)).map((i) => i.match(/(?:\/).*?(?=.html)/g)?.[0]) : '';
    return [...new Set(urlKeys)];
  },
  convertMagentoLink: (content) => {
    const context = useContext();
    const { magentoBaseUrl } = context.$vsf.$magento.config;
    // convert background image link
    content = ((content) => {
      return content.replace(/(?:data-background-images=\").*?(?:\")/g, function (x) {
        const url = x.match(/((https|http|ftp|rtsp|mms)?:\/\/).*?(bmp|jpg|png|gif|raw|webp|jpeg)/)?.[0]??''
        return 'data-background-images="' + url + '"';
      });
    })(content);
    // convert cms page link
    content = ((content) => {
      return content.replace(/(?:href=\").*?(?:\")/g, function (x) {
        const regex = new RegExp(/media\/wysiwyg|media\/cms/);
        return regex.test(x)?x:x.replace(magentoBaseUrl, '');
      });
    })(content);
    return content;
  },
  matchUrl: (content) => {
    const router = useRouter();
    const baseCode = router.options.base;
    const context = useContext();
    const localCode = context.$vsf.$magento.config.locale;
    content = ((content) => {
      return content.replace(/<a\s+[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>/g, function (match, href, text) {
        if (startsWith(href, 'https://') || startsWith(href, 'http://')) {
          return  match.replace(
            /(href=")([^"]*)"/i,
            () => `href="${href}"`
          );
        } else {
          const newHref = startsWith(href, '/') ? href.slice(1, href.length) : href;
          const prevHref = localCode === 'en' ? baseCode + localCode + '/' : baseCode;
          return  match.replace(
            /(href=")([^"]*)"/i,
            () => `href="${prevHref}${newHref}"`
          );
        }
      });
    })(content);
    return content;
  },
  bindGtmEvent: (selector, callback) => {
    document.querySelector('#html-body').addEventListener('click', function(evt) {
      if (evt.target.matches(selector)) {
        callback(evt.target);
      }
    }, true); // Use Capturing
  },
  checkVideoType: (link, str) => link.indexOf(str) > -1,
});

export default PBHelper;
